import React from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import eventBus from 'general/js/event-bus';
import app, { EVENT_DEVICE_TYPE_CHANGED } from 'general/js/app';
import { NewsFeedListing } from 'components/news-feed';
import { getPattern } from './patterns';

const VISIBLE_NUMBER_OF_NEWS_STANDART = 3;

export default class NewsFeedPreview extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.data = this.getAttribute(this.refs.data, 'options');
        this.cardsList = JSON.parse(this.data);

        this.newsCardsList = null;
        this.statePrimaryButton = false;

        this.init();
    }

    init() {
        this.renderCardsList();

        this.addListener(this.refs.primaryButton, 'click', this.onClickPrimaryButton);

        this.reactDOMRender();
        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.changedRenderedViews);
    }

    onDestroy() {
        eventBus.removeListener(EVENT_DEVICE_TYPE_CHANGED, this.changedRenderedViews);
    }

    renderCardsList() {
        this.newsCardsList = this.cardsList;

        if (this.newsCardsList.length > VISIBLE_NUMBER_OF_NEWS_STANDART) {
            this.newsCardsList = this.cardsList.slice(0, VISIBLE_NUMBER_OF_NEWS_STANDART);
            this.statePrimaryButton = true;
        }
    }

    onClickPrimaryButton = (event) => {
        if (this.statePrimaryButton) {
            event.preventDefault();
            this.newsCardsList = this.cardsList;
            this.reactDOMRender();
            this.statePrimaryButton = false;
        }
    };

    reactDOMRender() {
        ReactDOM.render(
            <NewsFeedListing
                items={this.newsCardsList}
                pattern={this.getPattern()}
            />,
            this.refs.primaryWrapper
        );
    }

    changedRenderedViews = () => {
        this.reactDOMRender();
    };

    getPattern() {
        return getPattern(this.newsCardsList.length, app.deviceTypeByViewport);
    }
}
